import React, {useEffect} from "react";
import './signIn.css';
import Carousel from "./newPages/carousel/carousel";
import BackArrow from '../../assets/svg/arrow-left.svg'
import {useHistory, useLocation} from "react-router";
import FpRightSide from "./newPages/fPComponents/fpRightSide";


const ForgotPassword: React.FC = () => {
  const location = useLocation();
  const history = useHistory();


  return (
    <div className="signIn-mainPage" style={{display: "flex", height: "100%", width: "100%"}}>
      <Carousel />
      <div style={{width: "60%"}}>
        {(location.pathname === '/forgotPassword' || location.pathname === '/forgotPassword/resetPassword') &&
          <div
            onClick={() => {
              history.push('/signin');
              localStorage.removeItem('resetPassword_token')
              localStorage.removeItem('resetPassword_emailId')
            }}
            style={{height: "25px", margin: "24px 0px 0px 24px", cursor: "pointer", display: "flex", alignItems: "center", color: "#292D32", fontSize: "18px", fontWeight: 400}} >
            <img src={BackArrow} alt="back-arrow" style={{height: "13px", width: "17px"}} ></img><span style={{marginLeft: "9px"}}>Return to the login screen</span>
          </div>}
        {(location.pathname === '/forgotPassword/otpVerification') &&
          <div
            onClick={() => history.goBack()}
            style={{height: "25px", margin: "24px 0px 0px 24px", cursor: "pointer", display: "flex", alignItems: "center", color: "#292D32", fontSize: "18px", fontWeight: 400}} >
            <img src={BackArrow} alt="back-arrow" style={{height: "13px", width: "17px"}} ></img><span style={{marginLeft: "9px"}}>Back</span>
          </div>}
        <FpRightSide />
      </div>
    </div>
  );
};

export default ForgotPassword;